import { Layout, theme, Typography } from "antd";
import { useLocation } from "react-router-dom";
import EditDepartment from "../components/departments/EditDepartment";

const { Content } = Layout;

const DepartmentEdit = () => {
  const location = useLocation();
  const id = location.state.id;

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            DÜZƏLİŞ ET
          </Typography.Title>
          <EditDepartment id={id} />
        </div>
      </Content>
    </Layout>
  );
};

export default DepartmentEdit;
